import type { PersistedV2, PersistedTable } from './persistence.js';

export interface V1Snapshot {
  bankrollCents: number;
  rules: unknown;            // craps TableRules — opaque to core
  selectedDenomCents: number;
}

export function migrateV1ToV2(v1: V1Snapshot): PersistedV2 {
  const crapsStandard: PersistedTable = {
    rules: v1.rules,
    prefs: { selectedDenomCents: v1.selectedDenomCents },
    unlocked: true,
    unlockSeenInLobby: true,
    unlockedAt: 0,
  };

  return {
    bankrollCents: v1.bankrollCents,
    activeGame: null,
    lobby: { lastTableId: 'craps:standard' },
    games: {
      craps: { tables: { standard: crapsStandard } },
    },
  };
}
